<script>
    import { onMount } from "svelte";
    import browseOpts from "../../Stores/browseOptionsStore.js";
    import dbData from "../../Stores/utilityDBStore.js";
    import { fetchCurrentAuthToken, formRequestAction } from "../../scripts/awsUtils.js";
    import { updateOverlays } from '../../scripts/viewMap.js';
    import LPTitleView from "./LPTitleView.svelte";
    import LPBrowseDropdowns from "./LPBrowseDropdowns.svelte";
    import WPNItemsTable from "../Misc/WPNItemsTable.svelte";
    import LPDetailView from "./LPDetailView.svelte";
    import { filterForMatchingItems, sortByStatus } from "../../scripts/wpn2Browse.js";
    import { downloadToFile } from "../../scripts/webUtil.js";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let searchCat;
    export let browsableData;
    export let detailItem = null;
    export let actionButtons;
    export let cellButtonTypes;
    let filteredData = [];
    let lpTitle;
    let searchText;
    // let browseCat;

    $: lpTitle = searchCat.title;
    $: searchText = $browseOpts[searchCat.name].searchText;
    // $: browseCat = searchCat.name;

    onMount(() => {
        let matchingItems = filterForMatchingItems(browsableData, $browseOpts[searchCat.name]);
        filteredData = searchCat.name === 'nhm' ? sortByStatus(matchingItems, -1) : matchingItems;
    });

    function recalculateFilteredData(event) {
        if (event != null && event.detail != null) {
            if (event.detail.name == "dd1") {
                browseOpts.updateDD1(searchCat.name, event.detail.value);
            } else if (event.detail.name == "dd2") {
                browseOpts.updateDD2(searchCat.name, event.detail.value);
            } else if (event.detail.sText != undefined) {
                browseOpts.updateSearchText(searchCat.name, event.detail.sText);
            }
            const matchingItems = filterForMatchingItems(browsableData, $browseOpts[searchCat.name]);
            filteredData = searchCat.name === 'nhm' ? sortByStatus(matchingItems, -1) : matchingItems.sort();
        }
    }

    function updateFilteredData(event) {
        if (event != null && event.detail != null) {
            filteredData = event.detail.sortedData;
        }
    }

    function exportFilteredData() {
        try {
            let promise = new Promise(fetchCurrentAuthToken);
            promise.then((authToken) => {
                handleExport(authToken);
            });
        } catch (error) {
            alert(
                "An error has occurred, please check internet connection and try again."
            );
            console.log(error);
        }
        return;
    }

    async function handleExport(authToken) {
        try {
            const ra = formRequestAction("export", { wpn_id: $dbData.wpn_id, items: filteredData }, authToken);
            const resExport = await fetch(ra.url, ra.initData);
            if (resExport.ok) {
                const dataExport = await resExport.json();
                // for (let eName of Object.keys(dataCSV)) {
                //     const csvData = atob(dataCSV[eName]);
                //     const filename = eName + ".csv";
                //     downloadToFile(csvData, filename, "text/csv");
                // }
                const dataCSV = dataExport['csv'] ?? {};
                for (const [eName, base64CSV] of Object.entries(dataCSV)) {
                    writeCSVFile(eName, base64CSV)
                }
                const dataGeoJSON = dataExport['geo_json'] ?? {};
                writeGeoJSONFile($dbData.wpn_id, dataGeoJSON);
            }
        } catch(error) {
            console.error('Error sending Export request: ', error);
        }
    }

    function writeCSVFile(eName, base64CSV) {
        const csvData = atob(base64CSV);
        const filename = `${eName}.csv`;
        downloadToFile(csvData, filename, "text/csv");
    }

    function writeGeoJSONFile(geoName, geoJSONObject) {
        try {
            const geojsonText = JSON.stringify(geoJSONObject, null, 2);
            const filename = `${geoName}.geojson`;
            downloadToFile(geojsonText, filename, "application/geo+json");
        } catch (stringifyErr) {
            console.error(`Failed to stringify GeoJSON for ${geoName}:`, stringifyErr);
        }
    }

    function backButtonPressed() {
        if (detailItem['entity'] == 'SoundLocation') {
            updateOverlays([], 'SoundPath');
        }
        detailItem = null;
    }
</script>

{#if detailItem == undefined}
    <LPTitleView
        {lpTitle}
        {searchText}
        showSearch={true}
        willShowBackButton={false}
        matchCount={filteredData.length}
        totalCount={browsableData.length}
        on:search-text={recalculateFilteredData}
        on:close-search-table
    />
    <LPBrowseDropdowns
        {searchCat}
        actions={actionButtons}
        on:dd1={recalculateFilteredData}
        on:dd2={recalculateFilteredData}
        on:selector-changed={recalculateFilteredData}
        on:create
        on:export={exportFilteredData}
        />
    <WPNItemsTable
        items={filteredData}
        {cellButtonTypes}
        on:find-on-map
        on:item-select={(event) => (detailItem = event.detail.item)}
        on:item-remove
        on:item-add
        on:sort={updateFilteredData}
    />
{:else}
    <!-- on:print={printDetailItem} -->
    <LPDetailView
        item={detailItem}
        on:edit
        on:item-select={(event) => (detailItem = event.detail.item)}
        on:find-on-map={() => dispatch("find-on-map", { item: detailItem })}
        on:back={backButtonPressed}
        on:close-search-table
    />
{/if}
